/** Display precision only; never use a rounded percentage to authorize work. */
export function audioAvailability(completed:number|null,total:number):{percent:number|null;label:string} {
  if(completed===null||!Number.isFinite(completed)||!Number.isFinite(total)||total<=0)return {percent:null,label:'—'};
  const ready=Math.max(0,Math.min(total,completed));
  // Do not announce complete audio until every part is actually available.
  const percent=ready===total?100:Math.min(99.9,Math.round(ready*1000/total)/10);
  return {percent,label:`${percent}%`};
}
